import { DatePicker } from 'antd';
import { useTranslation } from 'react-i18next';
import { getTaskFieldMetadata } from './constants';
import { observer } from 'mobx-react-lite';
import { useTask } from './Provider';
import { AutoSaverFormItem } from './AutoSaverFormItem';
import { StageTaskType } from '@/store/Lifecycle/constants';
import { computeValidateStatus, formatDateToUTC, parseDateFromUTC } from './utils';

export const DateField = observer(() => {
  const { t } = useTranslation();
  const task = useTask<StageTaskType.Date>();
  const { name, value, validateStatus, help, isSaving, isReadOnly, required } = getTaskFieldMetadata(task);
  const date = parseDateFromUTC(value);

  const computedValidateStatus = computeValidateStatus(value, validateStatus);

  return (
    <AutoSaverFormItem
      name={name}
      initialValue={date}
      className="stage-task-input-field"
      hasFeedback
      validateStatus={computedValidateStatus}
      help={t(help)}
      required={required}
      getValueFromEvent={formatDateToUTC}
      normalize={parseDateFromUTC}
      saveOnChange
    >
      <DatePicker
        className="stage-task-input"
        placeholder={t('Select date')}
        format="MMM DD, YYYY"
        disabled={isReadOnly || isSaving}
        size="large"
      />
    </AutoSaverFormItem>
  );
});
